/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HoldingIssueField } from './holdingIssueField';

export interface HoldingIssue {
  status?: string | null;
  item?: string | null;
  fields?: Array<HoldingIssueField> | null;
}
